import { Helmet } from "react-helmet-async";

const SITE = "https://claira.uk";

type Props = {
  title: string;                 // unique, < 60 chars
  description: string;           // 50–160 chars
  path: string;                  // route path, e.g. "/screenings"
  type?: "website" | "article";
  jsonLd?: object | object[];    // optional structured data
  noindex?: boolean;             // for auth-gated routes
};

/**
 * Per-route head tags (title, description, canonical, og:*, optional JSON-LD).
 * Overrides the static head in index.html for JS-executing crawlers.
 * Use the brand suffix " — Claira" in the title where it fits within 60 chars.
 */
export function PageHead({ title, description, path, type = "website", jsonLd, noindex }: Props) {
  const url = `${SITE}${path}`;
  const ld = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {ld.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}